module.exports = __webpack_public_path__ + "static/appearance-6e54f6e21189f3149d6469adecc1ab42.jpg";